import { useEffect, useState } from "react";

import { getCouponAPI, Offer } from "../utils/API";

const MAX_ITEMS = 20;

export const useCategoryOffers = (category: string) => {
  const [offers, setOffers] = useState<Offer[]>([]);

  useEffect(() => {
    const fetchCategoryOffers = async () => {
      const { result, offers: allOffers } = await getCouponAPI();
      if (!result) return;

      const categoryKey = category.toLowerCase();
      const randomData = [...allOffers].sort(() => 0.5 - Math.random());
      const filteredData = randomData.filter((offer) =>
        offer.standard_categories.toLowerCase().includes(categoryKey)
      );

      const seenStores = new Set<string>();
      const uniqueByStore: Offer[] = [];
      for (const offer of filteredData) {
        const storeKey = offer.store?.trim().toLowerCase();
        if (!storeKey || seenStores.has(storeKey)) continue;
        seenStores.add(storeKey);
        uniqueByStore.push(offer);
        if (uniqueByStore.length === MAX_ITEMS) break;
      }

      setOffers(uniqueByStore);
    };

    fetchCategoryOffers();
  }, [category]);

  return offers;
};
